import { render, staticRenderFns } from "./ShiftAssignmentModal.vue?vue&type=template&id=347261a6&scoped=true"
import script from "./ShiftAssignmentModal.vue?vue&type=script&lang=js"
export * from "./ShiftAssignmentModal.vue?vue&type=script&lang=js"
import style0 from "./ShiftAssignmentModal.vue?vue&type=style&index=0&id=347261a6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347261a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('347261a6')) {
      api.createRecord('347261a6', component.options)
    } else {
      api.reload('347261a6', component.options)
    }
    module.hot.accept("./ShiftAssignmentModal.vue?vue&type=template&id=347261a6&scoped=true", function () {
      api.rerender('347261a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/attendances/settings/components/modals/ShiftAssignmentModal.vue"
export default component.exports